import * as React from "react";

import { cn } from "@/lib/utils";
import { LucideIcon, LucideProps } from "lucide-react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    containerClassName?: string;
    icon?: LucideIcon | null;
    onIconClick?: () => void;
}

function Icon({ icon: Icon, size, className, onClick }: { icon: React.FC<LucideProps>; size: number; className?: string; onClick?: () => void }) {
    return <Icon className={cn(`h-${size}`, `w-${size} cursor-pointer`, className)} onClick={onClick} />;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, containerClassName, type, icon, onIconClick, ...props }, ref) => {
    return (
        <div className={cn("relative", containerClassName || "w-full")}>
            <input
                type={type}
                className={cn(
                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                    className,
                    icon && "pl-8"
                )}
                ref={ref}
                {...props}
            />
            {icon && (
                <Icon
                    icon={icon}
                    size={4}
                    className={"absolute left-2 top-1/2 -translate-y-1/2"}
                    onClick={() => {
                        if (onIconClick) {
                            onIconClick();
                        }
                    }}
                />
            )}
        </div>
    );
});
Input.displayName = "Input";

export { Input };
